import * as React from 'react';
import styles from './extend-error-message.module.scss';
import { sendProgressiveErrorUtag } from '~/utils/tealium';
import { useSelectedPaymentOption } from '~/store/wmap-store';
import { TYPES } from '~/modules/payment/constants';

export interface ICheckoutErrorData {
  errorHeading: string;
  errorMessage: string;
  errorList: string[];
  eventLabel?: string;
}

const CheckoutError: React.FC<ICheckoutErrorData> = ({
  errorHeading,
  errorMessage,
  errorList,
  eventLabel,
}) => {
  const sentEventsRef = React.useRef<Set<string>>(new Set());
  const selectedPaymentMethod = useSelectedPaymentOption();
  const isProgressiveSelected = selectedPaymentMethod === TYPES.PROGRESIVE;

  React.useEffect(() => {
    if (
      eventLabel &&
      isProgressiveSelected &&
      !sentEventsRef.current.has(eventLabel)
    ) {
      sendProgressiveErrorUtag(eventLabel);
      sentEventsRef.current.add(eventLabel);
    }
  }, [eventLabel, isProgressiveSelected]);
  return (
    <div className={styles.section}>
      <p className={styles.title} tabIndex={0}>
        {errorHeading}
      </p>
      <ul className={styles.message} tabIndex={0}>
        {errorList.map((error, index) => (
          <li key={index}>{error}</li>
        ))}
      </ul>
      <p className={styles.message} tabIndex={0}>
        {errorMessage}
      </p>
    </div>
  );
};

export default CheckoutError;
